import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '服务分类', href: '/category/all' },
  { label: '新闻资讯', href: '/category/news' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
            <i className="ri-cloud-line text-lg text-white"></i>
          </div>
          <span className={`text-xl font-bold font-heading transition-colors duration-300 ${
            scrolled || !isHome ? 'text-foreground-900' : 'text-white'
          }`}>
            开云官网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href));
            return (
              <Link
                key={link.href}
                to={link.href}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/85 hover:text-white'
                } ${isActive ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
              >
                {link.label}
                {isActive && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about#contact"
            className={`px-4 py-2 text-sm font-medium rounded-md border transition-all duration-200 whitespace-nowrap ${
              scrolled || !isHome
                ? 'border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-500'
                : 'border-white/40 text-white hover:border-white hover:bg-white/10'
            }`}
          >
            安全登录
          </Link>
          <Link
            to="/about#contact"
            className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            立即注册
          </Link>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
            scrolled || !isHome ? 'text-foreground-800' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-50 text-primary-600' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-2 mt-3 pt-3 border-t border-background-200/60">
              <Link to="/about#contact" className="flex-1 px-3 py-2.5 text-sm font-medium text-center rounded-md border border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                安全登录
              </Link>
              <Link to="/about#contact" className="flex-1 px-3 py-2.5 text-sm font-medium text-center rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap">
                立即注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}